import { Box, Modal, Stack, TextField, Typography } from "@mui/material";
import { GiftItem } from "../../../../interface/MainInterface";

interface PropsType {
  openModal: boolean;
  closeModal: () => void;
  gifts: GiftItem[];
}

const GiftInfoModule = ({ openModal, closeModal, gifts }: PropsType) => {
  return (
    <Modal
      open={openModal}
      onClose={closeModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "400px",
          bgcolor: "background.paper",
          border: "0px solid #000",
          borderRadius: "4px",
          boxShadow: 24,
          p: 2,
        }}
      >
        <Stack spacing={2} useFlexGap>
          <Stack direction="row" sx={{ justifyContent: "space-between" }}>
            <Typography sx={{ fontWeight: 700, fontSize: "16px" }}>경품 목록</Typography>
            <Box
              component="img"
              src="/images/icon-close.png"
              alt="닫기"
              sx={{
                width: 15.84,
                height: 16.95,
                objectFit: "cover",
                cursor: "pointer",
              }}
              onClick={closeModal}
            />
          </Stack>
          {gifts.map((gift, index) => (
            <Stack
              key={`gift_${index}`}
              spacing={2}
              sx={{
                border: "1px solid #ddd",
                borderRadius: 2,
                p: 2,
                bgcolor: "#fafafa",
              }}
            >
              <Typography fontWeight={700}>경품 #{index + 1}</Typography>

              <Stack direction="row" spacing={1} alignItems="center">
                <TextField label="경품명" value={gift.ofrNm} size="small" disabled />
                <TextField label="경품수량" value={gift.offrQty} size="small" disabled />
              </Stack>

              <Box
                component="img"
                src={gift.imgPath}
                sx={{
                  width: 120,
                  height: 120,
                  objectFit: "cover",
                  borderRadius: 2,
                  border: "1px solid #ddd",
                }}
              />
            </Stack>
          ))}
        </Stack>
      </Box>
    </Modal>
  );
};

export default GiftInfoModule;
